import React from "react";
import "./ConfirmModal.css";
import { Button } from '@mui/material';

const ConfirmModal = ({ show, type = "success", message, onClose, onConfirm }) => {
    if (!show) return null;

    const isSuccess = type === "success";
    const isError = type === "error";
    const isConfirm = type === "confirm";

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className={`modal-content 
          ${isSuccess ? "modal-success" : ""} 
          ${isError ? "modal-error" : ""} 
          ${isConfirm ? "modal-confirm" : ""}
        `}
                onClick={(e) => e.stopPropagation()}
            >
                <h3>
                    {isSuccess
                        ? "Sucesso"
                        : isError
                            ? "Atenção"
                            : isConfirm
                                ? "Confirmação"
                                : ""}
                </h3>

                <p>{message}</p>

                <div className="modal-buttons">
                    {onConfirm ? (
                        <>
                            <Button
                                variant="outlined"
                                onClick={onClose}
                            >
                                Cancelar
                            </Button>

                            <Button
                                variant="contained"
                                onClick={onConfirm}
                            >
                                Confirmar
                            </Button>
                        </>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={onClose}
                        >
                            Fechar
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;